import React, {RefObject} from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {TopBannerBox} from "./boxes/top-banner/top-banner.box";
import {TopBannerImageBox} from "./boxes/top-banner-image/top-banner-image.box";
import {TopBannerLogoImageBox} from "./boxes/top-banner-logo-image/top-banner-logo-image.box";
import {TopBannerTitleBox} from "./boxes/top-banner-title/top-banner-title.box";
import {TopBannerLiveLogoBox} from "./boxes/top-banner-live-logo/top-banner-live-logo.box";
import {ThemeProvider} from "styled-components";
import {AnimatedTopImageComponent} from '../animated-top-image/animated-top-image.component';

export interface TopImageComponentProps {
    image: string;
    animatedBanner?: string;
    title?: string;
    altText?: string;
    className?: string;
    topImageRef?: RefObject<HTMLDivElement>;
}

export const TopImageComponent = observer(class TopImageComponent extends OrbitComponent<TopImageComponentProps> {

    private _renderLogoAndTitle() {
        if(this.props.title) {
            const srcLogo = this.services.device.isMobile
                ? this.services.theme.currentTheme.images.liveArena.casinoLiveLogoMobile.toString()
                : this.services.theme.currentTheme.images.liveArena.casinoLiveLogoPC.toString();
            return (
                <TopBannerLiveLogoBox>
                            <TopBannerLogoImageBox
                                className={'cy-top-banner-logo-image'}
                                alt={this.services.translation.translate(this.props.title) + " Logo"}
                                src={srcLogo}
                            />
                    <TopBannerTitleBox className={'cy-top-banner-title'}>{this.services.translation.translate(this.props.title)}</TopBannerTitleBox>
                </TopBannerLiveLogoBox>
            )
        }
        return null;
    }

    render() {

        if (!this.props.image) {
            return null;
        }

        // TODO: maybe get also an image placeholder to enable lazy loading
        return (
            <ThemeProvider theme={this.services.theme.currentTheme}>
                <TopBannerBox ref={this.props.topImageRef} className={'cy-top-banner'}>
                    {this.props.animatedBanner ?
                    <AnimatedTopImageComponent image={this.props.animatedBanner} />
                    :
                    <TopBannerImageBox
                        alt={this.services.translation.translate(this.props.title || this.props.altText || "")}
                        src={this.props.image}
                        className={'cy-top-banner-image'}
                    />}
                    {this._renderLogoAndTitle()}
                </TopBannerBox>
            </ThemeProvider>
        )

    }
});
